// SafeFontAwesomeIcon.js
import { FontAwesomeIcon as OriginalFontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

export default function SafeFontAwesomeIcon({ icon, className = '', ...rest }) {
  if (!icon) {
    console.warn(
      'SafeFontAwesomeIcon: Missing or undefined icon prop.',
      { props: rest }
    );
    console.trace(); // shows which component is calling it
    return <OriginalFontAwesomeIcon icon={faCircleQuestion} className={className} {...rest} />;
  }

  return <OriginalFontAwesomeIcon icon={icon} className={className} {...rest} />;
}
